import { combineReducers } from 'redux';

import digitalCertificate from './digitalCertificate';
import loadingStatus from './loadingStatus';
import mobile from './mobile';
import password from './password';

export default combineReducers({
  digitalCertificate,
  loadingStatus,
  mobile,
  password,
});
